module.exports = __webpack_public_path__ + "static/media/sw-logo-full.060afe5c.png";